<template>
    <div>
        <v-combobox v-model="tax_id" 
            :items="taxes" 
            item-value="id"
            item-text="name"
            :search-input.sync="search"
            hide-details
            @click="INPUT"
            :placeholder="childplaceholder" 
            :clearable="clearable"
            class="form-control form-control-sm" :class="childclass">
            <template v-slot:no-data>
                <v-list-item>
                    {{ loading ? 'Buscando...' : 'No hay datos disponibles'}}
                </v-list-item>
            </template>
        </v-combobox>
    </div>
</template>
<script>
export default {
    props: {
        tax: '',
        childplaceholder: '',
        childclass: '',
        clearable: false
    },
    model: {
        prop: 'tax_id',
        event: 'blur'
    },
    data(){
        return{
            loading: false,
            search: '',
            taxes: [],
            enter: 0,
            name: null
        }
    },
    computed: {
        tax_id: {
            get: function() {
                let vue = this
                return vue.tax ? vue.tax : vue.name
            },
            set: function(value) {
                let vue = this
                vue.enter = 0
                vue.taxes = []
                vue.loading = false
                if(value){
                    vue.name = value
                    vue.$emit('blur', value.id)
                }else{
                    vue.$emit('blur', null)
                }
            }
        },
    },
    methods: {
        TAXES: function () {
            let vue = this
            let search = vue.search ? vue.search : ''
            axios({
                url: '/search/taxes?query=' + search,
                method: 'GET'
            })
                .then((resp) => {
                    vue.taxes = resp.data
                })
                .catch((err) => {
                    if (err.response.status === 402) {
                       let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    } else {
                        vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    }
                })
                .finally((resp) => {
                    vue.loading = false
                })
        },
        INPUT: function(e){
            let vue = this
            if(vue.taxes.length == 0){
                if(!vue.tax || !e.srcElement.value){
                    vue.loading = true
                    vue.TAXES()
                }
                if(vue.tax){
                    if(vue.tax.length == 0){
                        vue.TAXES()
                    }
                }
            }
        },
    },
    watch: {
        search: {
            handler(value) {
                let vue = this
                vue.taxes = []
                if (value) {
                    vue.loading = vue.enter == 0 ? false : true
                    setTimeout(() => {
                        if(vue.search){
                            if (vue.search.length == value.length && vue.enter == 1) {
                                vue.TAXES()
                            }
                        }else{
                            vue.loading = false
                        }
                        vue.enter = 1
                    }, 500)
                } else {
                    vue.loading = false
                }
            }
        },
        name: function(){
            let vue = this
            vue.name = vue.tax ? vue.tax : vue.name
        }
    }
}
</script>